import { useContext } from "react";
import { CookieContext } from "../context/context.cookie.tsx";

export function useCookie() {
  const { cookie, changeCookie } = useContext(CookieContext);
  /*
  useEffect(() => {
    if (!cookie) {
      openModal("cookie-notice");
    }
  }, []);
  */

  const ackCookie = () => {
    changeCookie(true);
  };

  const declineCookie = () => {
    changeCookie(false);
  };

  return { cookie, ackCookie, declineCookie };
}
